import { GoogleOAuthProvider } from '@react-oauth/google';
import getConfig from 'next/config';
import type { ReactNode } from 'react';
import { GoogleAuthTrigger } from './GoogleAuthTrigger';

const GoogleAuthWrapper = ({ children }: { children: ReactNode }) => {
  const { publicRuntimeConfig } = getConfig();
  const clientId = publicRuntimeConfig.googleEmailSyncClientId;

  if (!clientId) {
    console.error('[GoogleAuthWrapper] - clientId is not provided!');
    return <>{children}</>;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleAuthTrigger>{children}</GoogleAuthTrigger>
    </GoogleOAuthProvider>
  );
};

export { GoogleAuthWrapper };
